/**
 * Query to fetch all available marketplace features
 */
const allFeaturesQuery = `
query GetAllFeatures {
  marketplace_features(first: 1000, order: [name_ASC]) {
    edges {
      node {
        objectId
        name
        label
        description
        plans { ... on Element { value } }
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default allFeaturesQuery;
